import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const sessionInformation202610: BlogMetaData = {
  title: '2026年10月20日（火）入園説明会開催のお知らせ',
  description:
    '2026年10月20日（火）13:00〜14:00に、入園をご検討中のご家庭向けの入園説明会を開催します。当園の教育方針のご説明と個別Q&Aを行います。参加無料・お子様同伴可です。',
  thumbnailUrl: '/img/first-view-image1.webp',
  filePath: buildBlogFilePath('2026_10-session-information'),
  category: BLOG_CATEGORY.NEWS,
};
